import { useAppStore } from "../../../../../context/store";
import { Dialog, Portal, CloseButton, Button, Text } from "@chakra-ui/react";

import { useMapObjects } from "../../../../../context/MapObjectsContext";
import { loadOsmTypeAsync } from "../../../../../utilies/loader/LoadOSM";

const LoadGeneratedOsmDialog = () => {
  const showLoadGeneratedOsmDialog = useAppStore((s) => s.showLoadGeneratedOsmDialog);
  const setShowLoadGeneratedOsmDialog = useAppStore.getState().setShowLoadGeneratedOsmDialog;
  const viewerRef = useAppStore.getState().viewerRef;
  const { mapObjects, setMapObjects, mapObjectsRef } = useMapObjects();
  const setActiveLayer = useAppStore.getState().setActiveLayer;
  const defaultOsmStyle = useAppStore((s) => s.defaultOsmStyle);
  const defaultGeojsonStyle = useAppStore((s) => s.defaultGeojsonStyle);
  const basicGeojsonStyle = useAppStore((s) => s.basicGeojsonStyle);

  async function load() {
    let url = showLoadGeneratedOsmDialog;
    let timeoutMs = 30000;
    const controller = new AbortController(); // Create abort controller for timeout
    const timer = setTimeout(() => controller.abort(), timeoutMs); // Start timeout

    try {
      const res = await fetch(url, { signal: controller.signal }); // Fetch the URL
      if (!res.ok) throw new Error(`HTTP ${res.status} ${res.statusText}`); // Basic status check

      await loadOsmTypeAsync({
        arrayBuffer: await res.arrayBuffer(),
        fileName: url,
        viewerRef,
        setMapObjects,
        setActiveLayer,
        defaultOsmStyle,
        defaultGeojsonStyle,
        basicGeojsonStyle,
      });
      setShowLoadGeneratedOsmDialog(null);
      // return await res.arrayBuffer(); // Convert and return as ArrayBuffer
    } catch (err) {
      if (err.name === "AbortError") {
        throw new Error(`Fetch timed out after ${timeoutMs} ms`); // Normalize timeout error
      }
      throw err; // Re-throw other errors
    } finally {
      clearTimeout(timer); // Clean up timeout
    }
  }

  return (
    <Dialog.Root
      lazyMount
      closeOnInteractOutside={false}
      open={showLoadGeneratedOsmDialog == null ? false : true}
      onOpenChange={(e) => {
        if (!e.open) setShowLoadGeneratedOsmDialog(null);
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title> Confirmation</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Text>Should the generated OSM be loaded in the menu?</Text>
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline">Cancel</Button>
              </Dialog.ActionTrigger>
              <Button onClick={load}>Load</Button>
            </Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default LoadGeneratedOsmDialog;
